let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aQi3k")).then(() => parcelRequire('d22qs'));